import { Helmet } from 'react-helmet-async';
import { PlayerPosition } from '../../utils/constants';

const ProfileMetaTags = ({ userDetails, teamName, userId }) => {
    // Generate dynamic meta tags for social media sharing
    const profileMetaTitle = userDetails
        ? `${userDetails.firstName} ${userDetails.lastName} - PLAYER Profile`
        : 'PLAYER - The platform & app for footballers';

    const profileMetaDescription = userDetails
        ? `Check out ${userDetails.firstName} ${userDetails.lastName}'s profile on PLAYER. ${teamName ? `Currently at ${teamName}` : 'Footballer'}. ${userDetails.position ? PlayerPosition[userDetails.position] : ''}`
        : 'Join the ultimate platform for footballers. Showcase your talent, connect with scouts, and take your career to the next level.';

    const profileMetaImage =
        userDetails?.profilePictureUrl ||
        `${window.location.origin}/images/og-image.jpg`;

    const profileCanonicalUrl = `${window.location.origin}/profile${userId ? `?id=${userId}` : ''}`;

    return (
        <Helmet>
            <title>{profileMetaTitle}</title>
            <meta name='description' content={profileMetaDescription} />

            {/* Open Graph / Facebook */}
            <meta property='og:type' content='profile' />
            <meta property='og:url' content={profileCanonicalUrl} />
            <meta property='og:title' content={profileMetaTitle} />
            <meta property='og:description' content={profileMetaDescription} />
            <meta property='og:image' content={profileMetaImage} />
            <meta property='og:image:width' content='1200' />
            <meta property='og:image:height' content='630' />
            <meta property='og:site_name' content='PLAYER' />

            {/* Twitter */}
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:url' content={profileCanonicalUrl} />
            <meta name='twitter:title' content={profileMetaTitle} />
            <meta name='twitter:description' content={profileMetaDescription} />
            <meta name='twitter:image' content={profileMetaImage} />

            {/* Additional profile-specific tags */}
            {userDetails?.firstName && (
                <meta
                    property='profile:first_name'
                    content={userDetails.firstName}
                />
            )}
            {userDetails?.lastName && (
                <meta
                    property='profile:last_name'
                    content={userDetails.lastName}
                />
            )}

            <link rel='canonical' href={profileCanonicalUrl} />
        </Helmet>
    );
};

export default ProfileMetaTags;
